import { COLORS } from '@/theme';
import styled from 'styled-components';

export const StyledSkuLink = styled.a`
  &&& {
    cursor: pointer;
    text-decoration: underline;
    display: block;
    max-width: 100%;
  }
`;

export const StyledBadge = styled.div<{ $isActive?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 8.5rem;
  height: 1.5rem;
  border-radius: 1rem;
  padding: 0.3rem;
  background: ${({ $isActive }) => ($isActive ? COLORS.GREEN : COLORS.NORMAL_GRAY)};
  color: ${COLORS.WHITE};
`;
